import { render, staticRenderFns } from "./renderer.vue?vue&type=template&id=464a3518&scoped=true&"
import script from "./renderer.vue?vue&type=script&lang=js&"
export * from "./renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a3518",
  null
  
)

export default component.exports